/**
 * Deploy-time configuration, read off `<html>`'s `data-medialib-*` attributes.
 *
 * The shell is built once and promoted between stages, so anything that varies per
 * deployment (which environment this is, which release, which pilet feed) is declared
 * on the `<html>` tag in index.html rather than baked into the bundle. The release
 * assembler (`scripts/assemble-release.mjs`) stamps those attributes; a local
 * `just dev` build has none and every reader falls back to its development default.
 *
 * @param name The attribute name without the `data-` prefix, e.g. `medialib-env`.
 * @param fallback Used when the attribute is absent or blank.
 */
export function htmlData (name: string, fallback: string): string {
  if (typeof document === 'undefined') return fallback
  const value = document.documentElement.getAttribute(`data-${name}`)
  return value && value.trim() ? value.trim() : fallback
}
